export const keytrudaGreen = '#6cc04a';
export const consumerGreen = '#48a446';
export const keytrudaGreenWeb = '#2C6D3C';
export const keytrudaGreenWebForBanner = '#36864A';
export const keytrudaGreenBackground = '#e7f8e0';
export const baseGreen = '#F6FFED';

export const skyLight = '#a8dfff';
export const sky = '#70bdff';
export const blueberry = '#006ead';
export const blueberryDark = '#004a85';
export const ink = '#262626';
export const charcoal = '#444444';
export const slate = '#696969';
export const concrete = '#8c8c8c';
export const pebble = '#bebebe';
export const silver = '#dddddd';
export const mist = '#ebeaeb';
export const cloud = '#f3f3f3';
export const white = '#ffffff';
export const merckTeal = '#009999';
export const morning = '#6dceb2';
export const afternoon = '#86da64';
export const evening = '#28227e';
export const midnight = '#0c2340';
export const errorRed = '#db3933';
export const warningYellow = '#ffe105';
export const htmlPiBlack = '#000000';
export const lightPurple = "#7C02BB";
export const extraLightPurple = "#F8F2FC";
export const darkPurple = "#4A0075";

export const linearGradientPurple = "linear-gradient(106deg, #4A0075 0%, #5A008F 28.26%, #6A00A8 55.05%, #7C02BB 78.93%, #8215BA 101.34%)";
export const linearGradientGreen = "linear-gradient(107deg, #2C6D3C 9%, #2C6D3C 44.13%, #36864A 98.1%)";
export const greenWhiteGradient = "linear-gradient(90deg, #F0FAED 0%, #F0FAED 90.38%, #FFF 94.75%)";
